
import requestAPI from '@/logic/requestBeApi';

export default {
  props: {
    isFavorite: {
      default: false,
      type: Boolean,
    },
    subjectID: {
      required: true,
      type: String,
    },
    subjectName: {
      required: true,
      type: String,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },

  data(): Record<string, unknown> {
    return {
      requestPending: false,
      requestSent: false,
      addedToFavorites: false,
    };
  },

  computed: {
    showAsFavorite(): boolean {
      return this.requestSent ? this.addedToFavorites : this.isFavorite;
    },
  },

  methods: {
    async addToFavorites(): Promise<void> {
      if (this.readonly) return;

      this.requestPending = true;

      const resp = await requestAPI({
        method: 'PATCH',
        contentType: 'application/merge-patch+json',
        url: `/api/v1/favourites/${this.subjectID}/link`,
      });

      if (resp.ok) {
        this.requestSent = true;
        this.addedToFavorites = true;

        this.$message.success(this.$t('addedToFavorites', { subject: this.subjectName }));
      } else if (resp.status !== 401) {
        this.$message.error(this.$t('someErrorOccurred'));
      }

      this.requestPending = false;
    },

    async removeFromFavorites(): Promise<void> {
      if (this.readonly) return;

      this.requestPending = true;

      const resp = await requestAPI({
        method: 'DELETE',
        url: `/api/v1/favourites/${this.subjectID}/unlink`,
      });

      if (resp.ok) {
        this.requestSent = true;
        this.addedToFavorites = false;

        this.$message.success(this.$t('removedFromFavorites', { subject: this.subjectName }));
      } else if (resp.status !== 401) {
        this.$message.error(this.$t('someErrorOccurred'));
      }

      this.requestPending = false;
    },
  },
};
